import Vue from 'vue'
import VueRouter from 'vue-router'

// 解决重复点击路由会在控制台报错
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/HomePage.vue'),
  },
  {
    path: '/goodsInfo',
    name: 'GoodsInfo',
    component: () => import('@/views/GoodsInfo.vue'),
  },
  {
    path: '/payOrder',
    name: 'PayOrder',
    component: () => import('@/views/PayOrder.vue'),
  },
  {
    path: '/payOrderMt',
    name: 'PayOrderMt',
    component: () => import('@/views/PayOrderMt.vue'),
  },
  {
    path: '/myOrder',
    name: 'MyOrder',
    component: () => import('@/views/MyOrder.vue'),
  },
  {
    path: '/redemptionSuccess',
    name: 'RedemptionSuccess',
    component: () => import('@/views/RedemptionSuccess.vue'),
  },
  {
    path: '/integralDetail',
    name: 'IntegralDetail',
    component: () => import('@/views/IntegralDetail.vue'),
  },
  {
    path: '/pointsRule',
    name: 'PointsRule',
    component: () => import('@/views/pointsRule.vue'),
  },
  {
    path: '/addressList',
    name: 'AddressList',
    component: () => import('@/views/md/addressList.vue'),
  },
  {
    path: '/addressInfo',
    name: 'AddressInfo',
    component: () => import('@/views/md/addressInfo.vue'),
  },
  {
    path: '/dbg-myTest-login',
    name: 'Login',
    component: () => import('@/views/LoginPage.vue'),
  },
  { 
    path: '*',
    name: 'NoFound',
    component: () => import('@/views/404Page.vue'),
  }
]

const router = new VueRouter({
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes,
})

export default router
